import { render, staticRenderFns } from "./contactAndBasicInfo.vue?vue&type=template&id=5053c95a&scoped=true"
import script from "./contactAndBasicInfo.vue?vue&type=script&lang=js"
export * from "./contactAndBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./contactAndBasicInfo.vue?vue&type=style&index=0&id=5053c95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053c95a",
  null
  
)

export default component.exports